var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _path6, _path7, _path8, _path9, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _ellipse, _ellipse2, _ellipse3, _path20, _ellipse4, _ellipse5, _path21, _ellipse6, _path22, _path23, _path24, _path25, _ellipse7, _ellipse8, _path26, _path27, _path28, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _ellipse9, _ellipse10, _ellipse11, _rect7, _rect8, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDwarf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 184.7 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.8 30.7)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "m98.2 115.1 11.4 14-11.2 8.4-18.7-16.9Z",
    paintOrder: "markers fill stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#803f0f",
    d: "M103.7 127.8c-3.2 6.5-7.8 8.7-5 14 1.8 3.3 8.9 1 14.2-4 5.2-5 14.3-18.4 11.8-21.1-2.6-2.8-12.7-6-21 11.1z",
    paintOrder: "markers fill stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "m53.9 106-17 6 4.7 14 29.6-7.7z",
    paintOrder: "markers fill stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#803f0f",
    d: "M43.1 114.2c0 7.3 2 11.5-3.1 14.6-3.3 1.8-8-3.9-10-10.9-1.8-7-1.8-23.9 1.7-24.9 3.6-1 11.3 0 11.4 21.2z",
    paintOrder: "markers fill stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1c0d3",
    d: "M53.8 108s5.6 5.2 5.4 9.3c-.2 4.1 7.4 0 7.4 0s-2 4.3 5.5 6.2c7.6 1.8 10.6-2.3 10.6-2.3s1 4.3 3.1 1.8c5.3-6.1 9.4-5.9 14.5-9z",
    paintOrder: "markers fill stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.3,
    height: 17.3,
    x: 70,
    y: 79.2,
    fill: "#803f0f",
    ry: 1.5,
    transform: "rotate(10.8)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44.5,
    height: 17.3,
    x: 70.5,
    y: 79.2,
    fill: "#391c06",
    ry: 4.7,
    transform: "rotate(10.8)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 44.5,
    height: 17.3,
    x: 70,
    y: 79.2,
    fill: "#803f0f",
    ry: 4.5,
    transform: "rotate(10.8)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 13,
    x: 89.5,
    y: 84.2,
    fill: "none",
    stroke: "#ffda63",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    paintOrder: "markers fill stroke",
    ry: 2,
    transform: "rotate(10.8)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 13,
    x: 89,
    y: 84.3,
    fill: "none",
    stroke: "#eab400",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    paintOrder: "markers fill stroke",
    ry: 2,
    transform: "rotate(10.8)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 90.5,
    r: 1.2,
    fill: "#391c06",
    paintOrder: "markers fill stroke",
    transform: "rotate(10.8)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.2,
    cy: 90.5,
    r: 1.2,
    fill: "#391c06",
    paintOrder: "markers fill stroke",
    transform: "rotate(10.8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    stroke: "#803f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "M45.7 108.6 44 125.8",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    stroke: "#803f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "m43.7 109 2.6 16.4M104.4 122 97 136.5M105.4 123.4l-9.7 12.1",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f300c",
    d: "M33.5 113.3c.5 7.2 9.3 13.6 6.5 15.5-3.1 2-8-3.9-10-10.9-1.8-7-1.8-23.9 1.7-24.9 3.6-1 1.3 14.1 1.8 20.3zM110.7 134.1c-3.2 6.6-14.8 2.4-12 7.7 1.8 3.3 8.9 1 14.2-4 5.2-5 14.3-18.4 11.8-21.1-2.6-2.8-5.7.3-14 17.4z",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "m70 104.4-.8 4.6M77 112.8l-5-.8",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.8 30.7)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    d: "m45 80.8-9.8-17 4.6-4.1 10.4 8.7z",
    paintOrder: "stroke fill markers"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc5100",
    d: "M54.5 42.3c-.8 7.7-10.9 33.6-11.6 38-.6 4.2 1.6 11.4 7.9 9.5-1.4 2.5.8 9.6 7.5 7.3-1.7 3.2 2.7 10.1 8.6 5.3-1.6 2.8 5.5 7.8 9.2 3.6 1.9 5.3 10.4 3.2 9.8 0 3.8 6.7 10.4 1.9 10-1.7 5.4 4.6 10.1-1.3 9.7-4 5.2 4 9.9-1.9 10.8-6 1-4.3 1.7-31.4 3.8-39l-3.9-.5s-.5 10.8-2.8 13.3c-2.2 2.6-5 4.7-5 4.7L58 63.2s-1.7-3-2.8-6.2c-1.2-3.2 2.3-13.4 2.3-13.4z",
    paintOrder: "fill markers stroke"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 64.8,
    height: 29.9,
    x: 63.4,
    y: 25.6,
    fill: "#f5cfba",
    paintOrder: "markers fill stroke",
    ry: 1.2,
    transform: "rotate(10.8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    d: "M110.5 98 132 89V82l-14-1.3z",
    paintOrder: "stroke fill markers"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7729",
    d: "M54.7 42.9c-.8 7.8-10 33.2-10.7 37.6-.7 4.2 1.5 11.4 7.8 9.5-1.4 2.5.9 9.6 7.5 7.3-1.7 3.2 2.8 10.1 8.7 5.3-1.7 2.8 5.5 7.8 9.1 3.6 2 5.3 10.4 3.2 9.9 0 3.7 6.7 10.4 1.9 10-1.7 5.3 4.6 10-1.3 9.6-4 5.2 4 9.9-1.9 10.8-6 1-4.3 1.7-31.4 3.8-39l-3.8-.5s-.6 10.8-2.8 13.3c-2.3 2.6-5 4.7-5 4.7l-50.5-9.6s-1.7-3-2.9-6.2c-1.1-3.2 2.3-13.4 2.3-13.4z",
    paintOrder: "fill markers stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2a",
    d: "M100.6 75c-3.2 3.5-6.4 9.2-19 6.7-13.1-2.4-14-9.1-15.1-12.5-3.4-10.2 7.4-6.5 18.3-4.5 10.5 2 20.7 5 15.8 10.4Z",
    paintOrder: "fill markers stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.8 64.7c-3.5-.6-6.7-.9-9.5-.8l-.5 4.9c-.1 1 .6 1.8 1.5 2l6.2.6c1 .1 1.8-.6 2-1.6l.5-5h-.2z",
    paintOrder: "fill markers stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#d46354",
    d: "M86.5 74.4H86c-1.2-.3-1.7.5-2.6.3-1-.2-1.3-1.2-2.6-1.3-4-.6-7.4 2.1-8 5.2v.3c2 1.2 4.8 2.3 8.6 3 4.5 1 7.7.8 10.3 0a7 7 0 0 0-5.3-7.5z",
    paintOrder: "fill markers stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b0000",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m115.3 86.1-.7 7.6M111.5 92.4l-.4 4.8M115.8 79.3l.5-6.1",
    paintOrder: "stroke fill markers"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ac3f00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 8,
    d: "M57.4 71a12 12 0 0 1 14-9.7l26 5a12 12 0 0 1 9.5 14",
    paintOrder: "stroke fill markers"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "m84.6 68.4.4-3.6h-.2c-3.5-.7-6.7-1-9.5-1l-.4 3.7",
    paintOrder: "fill markers stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#dc5100",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 8,
    d: "M58.4 71.1a12 12 0 0 1 14.1-9.6l25.9 5a12 12 0 0 1 9.5 14",
    paintOrder: "stroke fill markers"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M96.2 82.7s-5 3-9.5 2.7M113 96.4l20.3-7.9",
    paintOrder: "stroke fill markers"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    paintOrder: "markers fill stroke",
    transform: "rotate(24.4 293 5.3) scale(1.24728)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.9,
    height: 93.4,
    x: 143,
    y: 37.5,
    fill: "#803f0f",
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535d6c",
    d: "M168.8 23.3c-.4 12.4-10.5 20.8-23 20.8-12.4 0-22.6-8.3-23-20.7-8.2 24.6 45.9 40 46-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b1c0d3",
    d: "M168.8 23.3a23 23 0 0 1-23 22.4 23 23 0 0 1-23-22.3c-4.6 3.5-8.3 8-10.7 13.2-.2.3-.6.6-.5 1l1.3 3.3c-.2.2-3.2 1.6-3.2 2a37.6 37.6 0 0 0 13.1 39.7 23 23 0 0 1 23-22.3 23 23 0 0 1 23 22.3c5-3.9 9-9 11.4-14.6.2-.4-1.3-2-1.2-2.4.2-.4 2 .3 2.2-.2a37.6 37.6 0 0 0-12.4-42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "M168.1 28.2a23 23 0 0 1-22.3 17.5 23 23 0 0 1-22.1-16.8 33.5 33.5 0 0 0-11 24.6A33.5 33.5 0 0 0 123.5 78a23 23 0 0 1 22.4-17.6 23 23 0 0 1 22.5 18.4 33.5 33.5 0 0 0 11.5-25.2A33.5 33.5 0 0 0 168 28.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 23.6,
    x: 140.8,
    y: 40.4,
    fill: "#535d6c",
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472209",
    d: "m143 63.7 4 1.6V64z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 23.6,
    x: 141.3,
    y: 40.4,
    fill: "#768395",
    ry: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.7,
    cy: 48.7,
    r: 2.3,
    fill: "none",
    stroke: "#b1c0d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.7,
    cy: 54.5,
    r: 2.3,
    fill: "none",
    stroke: "#b1c0d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b1c0d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m119.2 39.7 13.2 12-13.7 13M125.5 41.8v20.8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -154.9,
    cy: 48.7,
    r: 2.3,
    fill: "none",
    stroke: "#b1c0d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    opacity: 0.8,
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -154.9,
    cy: 54.5,
    r: 2.3,
    fill: "none",
    stroke: "#b1c0d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    opacity: 0.8,
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#b1c0d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m170.4 39.7-13.2 12 13.7 13M164 41.8v20.8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    d: "M123.2 31.3s-3.5 3-4.9 6M142.5 42.1v6.1m0 1.6v1.6",
    opacity: 0.8
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.9,
    cy: -146.6,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(-.12094 .99266 -.99999 -.0052 0 0)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5,
    cy: -146.7,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(-.12094 .99266 -.99999 -.0052 0 0)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -2.1,
    cy: -160,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.7,
    paintOrder: "stroke fill markers",
    rx: 1.7,
    ry: 2.4,
    transform: "matrix(-.6439 .7651 -.8288 -.55954 0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m116.2 80.6 12.5 1s4.1-5.6 5.5-1.7c3 8.2-6 9.7-3 2.8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.7,
    cy: 66.6,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(-.67134 .74115 .65844 .75263 0 0)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3,
    cy: 66.5,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.8,
    paintOrder: "stroke fill markers",
    rx: 2,
    ry: 3.7,
    transform: "matrix(-.67134 .74115 .65844 .75263 0 0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m45.5 81.6-10.8-19",
    paintOrder: "stroke fill markers"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.2,
    cy: 43.9,
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.7,
    paintOrder: "stroke fill markers",
    rx: 1.7,
    ry: 2.4,
    transform: "matrix(-.157 .9876 .9655 .26039 0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    d: "M34.3 62.2s-1.4-.4-2 .4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5cfba",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M50.2 68.9 43 61.4s1.5-6.7-2.3-5.2c-8.1 3-3.5 10.8-.2 4.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "m51.3 56 67.9 15.5.3-3.6-65.9-14.1Z",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.2,
    cy: -3.6,
    fill: "#fff",
    fillOpacity: 0.3,
    paintOrder: "markers fill stroke",
    rx: 1.5,
    ry: 2.4,
    style: {
      fontVariationSettings: "normal"
    },
    transform: "rotate(47)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b0000",
    stroke: "#933e00",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "m101 99.5-.3 4.2",
    paintOrder: "stroke fill markers"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.8 39.4)"
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8,
    cy: 58.9,
    fill: "#efe5c8",
    rx: 5.6,
    ry: 8.8,
    transform: "rotate(-51.3)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -71.5,
    cy: -107.8,
    fill: "#efe5c8",
    rx: 5.6,
    ry: 8.8,
    transform: "scale(-1 1) rotate(-72.9)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#768395",
    d: "M50.7 45.1a36.2 36.2 0 0 1 42-29.1 36.2 36.2 0 0 1 28.4 42.5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#dee4ef",
    d: "m87.4 40.2 4.3-23.4c.6-2.8-.7-3.2-2.6-3.5-1-.2-2 1.5-2.3 2.4L82.2 37c-10.5-1.6-19.8-1.4-29.1-1.4-1 0-1.4.6-1.6 1.6l-1.5 8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1c0d3",
    d: "M90.1 13.5c-1-.2-1.8.4-2 1.4l-5 22.8a184.7 184.7 0 0 0-29-1.9c-1 0-1.9.5-2 1.5l-1.6 8c-.2 1 .4 2 1.4 2.1 24 2.7 47.1 7.2 69.7 13.2 1 .3 1.9-.4 2-1.4l1.6-8c.2-1-.5-1.8-1.4-2.1a178.3 178.3 0 0 0-30.2-9.5l3.8-23c.2-1-.4-1.8-1.4-2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.8,
    cy: 30.9,
    r: 2,
    fill: "#768599",
    transform: "rotate(10.8)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 30.5,
    r: 2,
    fill: "#b1c0d3",
    transform: "rotate(10.8)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2,
    cy: 30,
    r: 0.6,
    fill: "#ced7e4",
    transform: "rotate(10.8)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.6,
    cy: 28.7,
    r: 2,
    fill: "#768599",
    transform: "rotate(10.8)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.2,
    cy: 28.4,
    r: 2,
    fill: "#b1c0d3",
    transform: "rotate(10.8)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 27.9,
    r: 0.6,
    fill: "#ced7e4",
    transform: "rotate(10.8)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.7,
    cy: 29.3,
    r: 2,
    fill: "#768599",
    transform: "rotate(10.8)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.3,
    cy: 28.9,
    r: 2,
    fill: "#b1c0d3",
    transform: "rotate(10.8)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.1,
    cy: 28.5,
    r: 0.6,
    fill: "#ced7e4",
    transform: "rotate(10.8)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 29.3,
    r: 2,
    fill: "#768599",
    transform: "rotate(10.8)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.1,
    cy: 28.9,
    r: 2,
    fill: "#b1c0d3",
    transform: "rotate(10.8)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.9,
    cy: 28.5,
    r: 0.6,
    fill: "#ced7e4",
    transform: "rotate(10.8)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.3,
    cy: 30.9,
    r: 2,
    fill: "#768599",
    transform: "rotate(10.8)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 30.5,
    r: 2,
    fill: "#b1c0d3",
    transform: "rotate(10.8)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.7,
    cy: 30,
    r: 0.6,
    fill: "#ced7e4",
    transform: "rotate(10.8)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.6,
    cy: 14.5,
    r: 2,
    fill: "#768599",
    transform: "rotate(10.8)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.2,
    cy: 14.1,
    r: 2,
    fill: "#b1c0d3",
    transform: "rotate(10.8)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 13.6,
    r: 0.6,
    fill: "#ced7e4",
    transform: "rotate(10.8)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.6,
    cy: 2.2,
    fill: "#768599",
    rx: 2,
    ry: 1.4,
    transform: "rotate(10.8)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.2,
    cy: 1.9,
    fill: "#b1c0d3",
    rx: 2,
    ry: 1.4,
    transform: "rotate(10.8)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 1.6,
    fill: "#ced7e4",
    rx: 0.6,
    ry: 0.4,
    transform: "rotate(10.8)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5.4,
    height: 18,
    x: 60.7,
    y: -27.2,
    fill: "#c4d0e1",
    ry: 2.7,
    transform: "rotate(40)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.4,
    height: 18,
    x: 97.5,
    y: -82.7,
    fill: "#c4d0e1",
    ry: 2.7,
    transform: "scale(1 -1) rotate(18.5)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e0e6ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    d: "M81.6 17.8c-2 0-4.2.6-6.4 1.5m-1.5.7c-.9.3-1 .4-1.9.9",
    paintOrder: "markers fill stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    d: "M51.1 19s1.6-1.8 5.2 0",
    paintOrder: "markers fill stroke"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7729",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M59.8 54.7s-2.1 1.8-3 4.2M56.3 63.8c-.7-.9-.6-1.7-.4-2.5",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    stroke: "#5c6b84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "m102.8 30.6 2.7 4.4",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7729",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M60.7 56s-2 1.4-3 4.2",
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    stroke: "#5c6b84",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.6,
    d: "m106 31.2-2.7 4",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    stroke: "#ff955a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 0.4,
    d: "M21.3 103.8 19 110M21.7 110.4l-1.3 4.8M31.7 121l-1.3 4.8M91.4 110.6l-.3 3.5M93.5 111l-.4 3M95.3 111l-.2 2.8M17 94.2l-2.6 2.2M18.5 95.6l-2.7 2.3",
    paintOrder: "markers fill stroke",
    style: {
      fontVariationSettings: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwarf);
export default __webpack_public_path__ + "static/media/dwarf.0e9a5771479f583436880bea884503b3.svg";
export { ForwardRef as ReactComponent };